function priveziNewsletter() {
    let newsPurposeObj = null;
    let newsLanguageListObj = [];

    //Document Step 2: Use the API key provided from the document
	var newsApiKey = 'SJ6IH2SBCK2RDEAWO3O709UP8MNBE3GTOQNJJ7JGEW2NLZ7WPHNQ6BWS9MTIW9JJC6RBZDNYZ0A162C5JXS8LFHS66ZPPFJZC5P4C8DO1NNAKW6IQVF4XA5J535KBMMRO3VVQUJUIRNVNO584W166OUIXT2HYD5T8QJ1DZFCOHX1VSNZIWI44UGIRN1IBXJMCEO6RQ3JIB2PX84MMC2CEB320NQC66D7E3PEZU0T3MO3HCTUO3R9P2WWJP7A996D';

	//Document Step 3: Calling the Get Consent Purposes API
    async function newsHandleToGetPurposeApi() {
      try {
        const newsResponse = await fetch(
          `https://api.voltasworld.com/edge-service/consent-service/getPurposesByConsentPoint/newsletter-Voltas.com?apiKey=${newsApiKey}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          });


        const newsJson = await newsResponse.json();
        newsPurposeObj = newsJson;
        newsLanguageListObj = newsJson?.languagesList;
        const newsUniqueLanguageKeys = {};


        // Collect all language keys from the API response
        newsPurposeObj.purposes.forEach((item) => {
          const newsLabels = item[Object.keys(item)[0]].labels;
          Object.keys(newsLabels).forEach((key) => {
            const newsNormalizedKey = key === 'default' ? 'English' : key;
            if (!newsUniqueLanguageKeys.hasOwnProperty(newsNormalizedKey)) {
              newsUniqueLanguageKeys[newsNormalizedKey] = newsLabels[key];
            }
          });
        });
        console.log("newsUniqueLanguageKeys", newsUniqueLanguageKeys)

		//Adding languages to the Drop Down
        newsRenderLang(newsUniqueLanguageKeys);

		//Adding checkboxes to the page
        newsRenderCheckboxes('English');
      } 
	  catch (newsError) {
        console.error('API fetch error:', newsError);
        newsRenderCheckboxes('English');
      }
  }

    newsHandleToGetPurposeApi();

    var newsCheckboaxwrapper = document.getElementById("newsPurposeCheckConsent");


    function newsGetdataAsPerLang(newsValue, newsLang) {
      console.log("newsGetdataAsPerLang", {newsValue, newsLang})
      const newsLabels = Object.values(newsValue)[0].labels;
      console.log("newsGetdataAsPerLang 1", newsLabels)

      return newsLabels[newsLang] || newsLabels.default || 'Default Label';

    }

    function newsRenderLang(newsLanguageArray) {
      const newsKeysArray = Object.keys(newsLanguageArray).map((key) =>
        key === 'default' ? 'English' : key
      );
      console.log("newsKeysArray",{newsLanguageArray, newsKeysArray})
      if (newsKeysArray.length) {
        const newsLanguageContainer = document.getElementById('newsLanguage');
        newsLanguageContainer.innerHTML = `
                  <div>Change Language</div>
                  <select id="languageSelect" style="width: auto; display: inline-block; margin-top: 10px;">
                    ${newsKeysArray
            .map(
              (newsLang, newsIndex) => `<option value="${newsLanguageListObj?.find((ele)=> ele.name == newsLang)?.id || 0}" ${newsLang === 'English' ? 'selected' : ''}>${newsLang}</option>`
            )
            .join('')}
                  </select>
                `;

        // Add change event listener to dropdown
        document.getElementById('languageSelect').addEventListener('change', function (e) {
          const newsSelectedLang = e.target.value;
          const newsSelectEl = e.target;
          const newsSelectedValue = newsSelectEl.value;
          const newsSelectedText = newsSelectEl.options[newsSelectEl.selectedIndex].textContent;
          console.log('languages newsSelectedText:', newsSelectedText);
          newsRenderCheckboxes(newsSelectedText);
        });
      } else {
        console.error('No languages available:', newsKeysArray);
      }

    }

    function newsRenderCheckboxes(newsLang) {
         if (!newsLang) {
          console.error(`Element with ID ${newsLang} not found`);
          return;
        }
      // Clear previously rendered checkboxes
      newsCheckboaxwrapper.innerHTML = '';
      //  var intNews = setInterval(() => {
        // if(checkboaxwrapper.children.length === 0 && checkboaxwrapper.textContent.trim() === ""){
          // console.error('No checkboxes rendered');
          if (newsPurposeObj && newsPurposeObj.purposes) {
            newsPurposeObj.purposes.forEach((newsPurpose) => {
              const newsPurposeKey = Object.keys(newsPurpose)[0].replace(/\s+/g, '');
              console.log("newsPurposeKey",newsPurposeKey)
              const newsIsRequired = Object.values(newsPurpose)[0].is_required;
              const newsLabelHTML = newsGetdataAsPerLang(newsPurpose, newsLang); // Get label for selected language


              newsCheckboaxwrapper.innerHTML += `
            <div class="checkbox">
              <input type="checkbox" id="${newsPurposeKey}" name="${newsPurposeKey}" ${newsIsRequired ? 'required' : ''}>
              <span class="danger">${newsIsRequired ? '* ' : ' '}</span>
              <label for="${newsPurposeKey}">${newsLabelHTML}</label>
            </div>
            `;
            });
          }
        // }
          
          
        // else {
        //   console.log('checkboxes rendered');
        //   clearInterval(intNews);
        // }
      // }, 1000);

    }


    const newsForm = document.getElementById('newsletter-footer');

    function newsGetvaluesfromChckbox() {
      let newsSetcheckVal = {};
      if (newsPurposeObj && newsPurposeObj.purposes) {
        newsPurposeObj.purposes.forEach((newsPurpose) => {
          const newsPurposeKey = Object.keys(newsPurpose)[0].replace(/\s+/g, '');
          newsSetcheckVal = {
            ...newsSetcheckVal,
            [newsPurposeKey]: document.getElementById(newsPurposeKey).checked,
          };
        });
      }
      return newsSetcheckVal;
    }

    newsForm.addEventListener('submit', async function (e) {

      e.preventDefault();

      // const langelement = document.querySelector('.langactive');
      // const textLangContent = langelement ? langelement.textContent : 'English';
      
      const newsLangSelect = document.getElementById('languageSelect');
      const newsSelectedOption = newsLangSelect.options[newsLangSelect.selectedIndex];
      const newsTextLangContent = newsSelectedOption.textContent; 
      const newsTextLangId = Number(newsSelectedOption.value);  
      const newsPurpose = newsGetvaluesfromChckbox();
      const newsPayload = new FormData(newsForm);
      const newsFormDataSer = Object.fromEntries(newsPayload);

      // const newsJsonObject = {
      //   ...newsFormDataSer,
      //   // ...purpose,
      // };
      // const newsDataint = newsFormDataSer.emailAddress;
      const newsDataint = newsPayload.get('contact[email]');
      const newsJsonObject = {
        emailAddress: newsPayload.get("contact[email]"),
      };
      try 
	  {
        const newsResponse = await fetch
		(
          "https://api.voltasworld.com/edge-service/consent-service/consentEntry/newsletter-Voltas.com",
          {
            method: 'POST',
            body: JSON.stringify({
              data: newsJsonObject,
              apiKey: newsApiKey,
              identifier: newsDataint,
              purpose: newsPurpose,
              language: newsTextLangContent,
              languageId: newsTextLangId,
            }),
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        if (newsResponse.ok) {
          const newsJson = await newsResponse.json();
          alert("Details saved successfully");
          newsForm.reset();
        } 
        else if (newsResponse?.status === 406) {
        // Specific handling for 406 with message from API
        const newsErrorMessage = newsResult?.error?.message || "it's looks like some value is missing";
        alert(newsErrorMessage);
      } else {
        // Generic error fallback
        const newsErrorMessage = newsResult?.error?.message || "An error occurred while submitting the form";
        alert(newsErrorMessage);
      }
      } 
	  catch (newsError) {
        console.error("Form submission error:", newsError);
        alert("An error occurred while submitting the form");
      }
    });
};
priveziNewsletter();